import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    name: 'HomeView',
    component: () => import('@/views/PortalHome.vue'),
    meta: {
      requiresAuth: true,
      roles: []
    }
  },

  {
    path: '/login',
    name: 'loginView',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      requiresAuth: false,
      roles: []
    }
  },

  {
    path: '/auth/backToPortal',
    name: 'BackToPortal',
    redirect: { name: 'HomeView' }
  },

  {
    path: '/app',
    name: 'OldRoute',
    redirect: { name: 'HomeView' }
  },

  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/UsersEdit.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  },

  {
    path: '/companies',
    name: 'companies',
    component: () => import('@/views/CompaniesEditView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  },

  {
    path: '/agents',
    name: 'agents',
    component: () => import('@/views/AgentsEditView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  },

  {
    path: '/pws',
    name: 'pws',
    component: () => import('@/views/PwsView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  },
  {
    path: '/links',
    name: 'links',
    component: () => import('@/views/LinkView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  },

  {
    path: '/groups',
    name: 'groups',
    component: () => import('@/views/GroupView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['Portal-Admin']
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    // not logged in
    if (!store.getters['auth/isUserLoggedIn']) {
      next({ path: '/login' });
    }

    // unauthorize
    else if (to.meta.roles.length > 0 && !store.getters['auth/roles'].some(role => to.meta.roles.some(roleRequired => role === roleRequired))) {
      next({ path: '/' });
    }

    // move forward
    else {
      next();
    }
  } else {
    next();
  }
});

const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch(e => e);
};

export default router;
